<div style="width: 300px; height: 300px; margin:auto">
  <qrcode [qrdata]="url" [width]="300"></qrcode>
</div>
